/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B4_DInputs */

const en_mk_abt_b4_d = /** @type {(inputs: Mk_Abt_B4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We publish an open list of what we do not have. A customer who leaves after reading it is better than one who leaves after subscribing.`)
};

const id_mk_abt_b4_d = /** @type {(inputs: Mk_Abt_B4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami menulis daftar terbuka tentang apa yang belum kami punya. Pelanggan yang pergi karena membaca daftar itu lebih baik daripada pelanggan yang pergi setelah berlangganan.`)
};

/**
* | output |
* | --- |
* | "We publish an open list of what we do not have. A customer who leaves after reading it is better than one who leaves after subscribing." |
*
* @param {Mk_Abt_B4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b4_d = /** @type {((inputs?: Mk_Abt_B4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b4_d(inputs)
	return en_mk_abt_b4_d(inputs)
});